module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "data-toggle": "modal",
      "data-target": '#' + _vm.polisnummer
    }
  }, [_c('p', {
    staticClass: "icon icon-sm"
  }, [_c('span', {
    class: 'icon-' + _vm.produkttypenaam
  })]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.produktnaam))]), _vm._v(" "), _c('span', [_vm._v("Polisnummer: " + _vm._s(_vm.polisnummer) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": _vm.polisnummer,
      "tabindex": "-1",
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.produktnaam))]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', [_vm._v("De details van deze verzekering zijn alleen beschikbaar bij " + _vm._s(_vm.maatschappijnaam) + ".")])]), _vm._v(" "), _vm._m(1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("x")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-modal-close",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Ok")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-87823ce6"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/frontend/components/polisnonvsp.vue
// module id = 26
// module chunks = 0